import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {formatPrice} from '../helpers';
import {TransitionGroup, CSSTransition} from 'react-transition-group';

class Order extends Component {

  state = {
      cartActive: false
    };

  static propTypes = {
    fishes: PropTypes.object,
    order: PropTypes.object,
    removeFromOrder: PropTypes.func
  };

  renderOrder = (key) => {
    const fish = this.props.fishes[key];
    const count = this.props.order[key];
    const isAvailable = fish && fish.status === 'available';
    const transitionOptions = {
      classNames: "order",
      key,
      timeout: {
        enter: 500,
        exit: 500
      }
    };
    // Make sure fish is loaded before continuing
    if (!fish)
      return null;

    if (!isAvailable) {
      return (<CSSTransition {...transitionOptions}>
        <li key={key}>
          Sorry {
            fish
              ? fish.name
              : 'fish'
          }
          is no longer available
        </li>
      </CSSTransition>);
    }
    return (<CSSTransition {...transitionOptions}>
      <li key={key}>
        <span>
          <TransitionGroup component="span" className="count">
            <CSSTransition classNames="count" key={count} timeout={{
                enter: 500,
                exit: 500
              }}>
              <span>{count}</span>
            </CSSTransition>
          </TransitionGroup>
          lbs {fish.name}
          {formatPrice(count * fish.price)}
          <button onClick={() => this.props.removeFromOrder(key)}>&times;
          </button>
        </span>
      </li>
    </CSSTransition>);
  };

  setCartState = () => {
    this.setState({
      cartActive: !this.state.cartActive
    });
  }

  goToCheckout = e => {
    this.props.history.push(`/store/fintastic/checkout`);
    console.log('Go to checkout');
  }

  render() {
    const orderIds = Object.keys(this.props.order);
    const total = orderIds.reduce((prevTotal, key) => {
      const fish = this.props.fishes[key];
      const count = this.props.order[key];
      const isAvailable = fish && fish.status === 'available';
      if (isAvailable) {
        return prevTotal + (count * fish.price);
      }
    }, 0);

    return (<div className="order-wrap">
      <button className="total" onClick={this.setCartState}>
        <span role="img">🛒 </span>Total: {formatPrice(total)}
      </button>

      {!this.state.cartActive ? null : (
           // If no orders, show welcome text
            total === 0 ? (
              <div className="shoppingDropdown">
                <h2>Welcome!</h2>
                <p>Your fish basket is empty. Go ahead and order some
                  <span role="img">🐟🐟🐟</span>
                </p>
              </div>)
            // If there are orders, show items
            : (<div className="shoppingDropdown">
                <h2>Order</h2>
                <TransitionGroup component="ul" className="order">
                  {orderIds.map(this.renderOrder)}
                </TransitionGroup>
                <button onClick={this.goToCheckout}>Checkout</button>
            </div>))
      }
    </div>);
  }
};

export default Order;



// WEBPACK FOOTER //
// ./src/components/Order.js